import { render, staticRenderFns } from "./bannerEdit.vue?vue&type=template&id=65c17984&scoped=true"
import script from "./bannerEdit.vue?vue&type=script&lang=js"
export * from "./bannerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c17984",
  null
  
)

export default component.exports